import { Component, OnInit } from '@angular/core';
import path from '../../config/path/path.json'
import { VhViethasWebAPPEndUser } from 'vhwebapp'


@Component({
  selector: 'app-webapp-software-c001-user-submenu',
  templateUrl: './webapp-software-c001-user-submenu.component.html',
  styleUrls: ['./webapp-software-c001-user-submenu.component.scss']
})

export class WebappSoftwareC001UserSubmenuComponent implements OnInit {

  name: string = ''

  sales =[]

  cafe = []
  cloud = []
  path : string = path.link
  constructor(
    private vhViethasWebAPPEndUser: VhViethasWebAPPEndUser
  ) { 

  }

  ngOnInit(): void {
    this.getCategorySoftware()
  }

  getCategorySoftware(){
      this.vhViethasWebAPPEndUser.getComponentContents('webapp_software_c001_categories').then((res : any) =>{
        const dataCategories = res.data.filter(v=>v.isShow)
        if(res.vcode === 0  && dataCategories){
           
            this.sales = dataCategories.filter(c => c.type == 1)
            this.cafe = dataCategories.filter(c => c.type == 2)
            this.cloud= dataCategories.filter(c => c.type == 3)
        } 
      })
    
  }

 
}
